import Button from "components/Button";
import Content from "components/Content";
import Label from "components/Label";
import useScreenSize from "hooks/use-screen-size";
import Image from "next/image";
import React, { FC } from "react";
import { useRouter } from "next/router";

import styles from "./styles.module.scss";

export interface Props {
  title: string;
  description: string;
  cta: { reads: string; to: string };
  image: string;
  pricing: string;
}

const Heading: FC<Props> = ({ title, description, cta, image, pricing }) => {
  const { isResponsive, isMobile } = useScreenSize();

  const router = useRouter();

  return (
    <Content
      contentClassName={styles.container}
      containerClassName={styles.wrapper}
    >
      <div className={styles.top}>
        <div className={styles.leftPanel}>
          <div className={styles.titleWrapper}>
            <Label
              className={styles.title}
              useMarkdown
              variant="h"
              color="lightPrimary"
            >
              {title}
            </Label>
          </div>
          <div className={styles.subtitleWrapper}>
            <Label
              className={styles.subtitle}
              useMarkdown
              variant="s"
              color="lightPrimary"
            >
              {description}
            </Label>
          </div>
          <Label
            className={styles.membershipName}
            variant="s-capitalized"
            color="supplemental"
          >
            Starting at
          </Label>
          <Label className={styles.pricing} variant="h" color="lightPrimary">
            {pricing}
          </Label>
          <Button
            onClick={() => {
              router.push(cta.to);
            }}
            variant="cta"
          >
            {cta.reads}
          </Button>
        </div>
        <div className={styles.rightPanel}>
          <Image
            alt=""
            src={image}
            layout="fixed"
            width={isResponsive ? (isMobile ? 250 : 300) : 450}
            height={isResponsive ? (isMobile ? 250 : 300) : 450}
          />
        </div>
      </div>
    </Content>
  );
};

export default Heading;
